import axios from "axios";
import {formatDate} from "devextreme/localization";

export default {
    version: '10121',
    language: 'de',

    session_token: null,
    user_id: null,

    googleApi: 'AIzaSyBoGEsyYZ30VYxAm7j0vQFS1kD43s-WhlM',

    menu: [{}],
    routes: [{}],

    // VUE_APP_API_SERVER (z.B. in webclient/.env.development.local) überschreibt den Server, etwa für lokales Arbeiten gegen Stage
    host: process.env.VUE_APP_API_SERVER ? process.env.VUE_APP_API_SERVER.replace(/\/?$/, '/') + 'api/' : ((document.location.origin === 'http://localhost:8080') || (document.location.origin === 'http://localhost:8081')) ? 'http://msa35.test/api/' : (document.location.origin === 'https://dev.myschleppapp.de')?'https://dev.myschleppapp.de/api/':'https://psa3.myschleppapp.de/api/',
    server: process.env.VUE_APP_API_SERVER ? process.env.VUE_APP_API_SERVER.replace(/\/?$/, '/') : ((document.location.origin === 'http://localhost:8080') || (document.location.origin === 'http://localhost:8081')) ? 'http://msa35.test/' : (document.location.origin === 'https://dev.myschleppapp.de')?'https://dev.myschleppapp.de/':'https://psa3.myschleppapp.de/',

    logo1: 'assets/msa_logo_white.svg',
    logo2: 'assets/msa_logo_red.svg',
    logo1_w: '70%',
    logo2_w: '20%',

    // logo1: 'assets/brand/fp/fp.png',
    // logo2: 'assets/brand/fp/fp_2.png',
    // logo1_w: '50%',
    // logo2_w: '40%',
    //
    sendRequest(className, id, attr, value) {
        return new Promise((resolve) => {
            return axios.post(this.host + "validation", {
                className: className,
                id: id,
                attribute: attr,
                value: value
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.session_token,
                    'last-update-ts': formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
                }
            }).then(response => {
                if (response.status === 200) {
                    resolve(true);
                }
            }).catch(() => {
                resolve(false);
            });
        });
    },

    updateHeight(component) {
        if (component)
            component.instance.option("height", (window.innerHeight) - 117);
        else
            return window.innerHeight - 44;
    }
};
